/** Must match Backend `DEPLOY_DATE_FIELD_ID`. */
export const DEPLOY_DATE_FIELD_ID = "diadeploy";
